"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = {
    primary: {
        light: '#cad5f4',
        main: '#204ecf',
        dark: '#1542c1'
    },
    text: {
        primary: '#455065'
    },
    grey: {
        50: '#dfe3e9',
        100: '#e8e8e8',
        200: '#c4c6ca',
        300: '#686869',
        500: '#262d3d'
    },
    blue: {
        lighter: '#eef1fc',
        light: '#dbe3f9'
    },
    warning: {
        light: '#fdf5e8',
        main: '#edad2a'
    },
    error: {
        lighter: '#fbedf1',
        light: '#f8b1b4',
        main: '#d42551',
        dark: '#9f3a38'
    },
    success: {
        lighter: '#edfbf5',
        light: '#b3ffe4',
        main: '#00cc83'
    },
    common: {
        black: '#000',
        white: '#fff'
    }
};
const palette = Object.assign({}, JSON.parse(JSON.stringify(exports.colors)), { background: {
        default: exports.colors.common.white
    } });
exports.default = palette;
//# sourceMappingURL=palette.js.map